import { useTranslation } from "react-i18next";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonHeader,
  IonLabel,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { classNames } from "utils/utils";
import React, { useRef, useEffect, useState } from "react";
import { Md2Loading } from "react-icons-ng/md2";
import { signInWithEmailLink } from "utils/login";
import { useHistory } from "react-router-dom";
import { useUser } from "reactfire";
import { useGame } from "context/gameContext";
import AppLogo from "components/appLogo";

const Nickname = React.lazy(() => import("../steps/nickname"));
const Photo = React.lazy(() => import("../steps/photo"));
const TermsAndConditions = React.lazy(() => import("../steps/terms"));

const NewUserOnboarding = ({ url, social, isNewSocialUser }) => {
  const { t } = useTranslation();

  const swiperOnboardRef = useRef(null);
  const nicknameRef = useRef(null);
  const termsRef = useRef(null);

  const history = useHistory();

  const [progress, setProgress] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: user } = useUser();

  const {
    state: { userGameData },
    dispatch,
  } = useGame();

  useEffect(() => {
    if (social) return;
    if (!url) {
      history.push("/");
      return;
    }
    dispatch({ type: "setHideBottomBar", value: true });
    signInEmailLink(url);
  }, []);

  useEffect(() => {
    if (!userGameData || !social) return;

    if (!isNewSocialUser && userGameData?.completedOnboarding) {
      dispatch({ type: "setHideBottomBar", value: false });
      history.push("/");
      return;
    } else {
      //Process social image
      /*       if (user?.photoURL) {
      } */

      dispatch({ type: "setHideBottomBar", value: true });
      setIsLoading(false);
      return;
    }
  }, [userGameData]);

  const signInEmailLink = async (url) => {
    try {
      let isNewUser = await signInWithEmailLink(url);

      if (!isNewUser) {
        dispatch({ type: "setHideBottomBar", value: false });
        history.push("/");
        setIsLoading(false);
        return;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      //history.push("/");
      console.log(error);
    }
  };

  useEffect(() => {
    const swiperContainer = swiperOnboardRef.current;
    const params = {
      navigation: false,
      autoHeight: false,
      spaceBetween: 50,
      slidesPerView: 1,
      initialSlide: 0,
      speed: 400,
      noSwiping: true,
      allowTouchMove: false,
      keyboard: false,
      noSwipingClass: "noSwipingClass",
      autoPlay: false,

      //effect: "coverflow",
    };

    Object.assign(swiperContainer, params);
    swiperContainer.initialize();
  }, []);

  useEffect(() => {
    swiperOnboardRef.current.addEventListener("progress", (e) => {
      const [swiper, progress] = e.detail;
      setProgress(progress);
    });
  }, []);

  const submitForm = (e) => {
    e.preventDefault();

    switch (swiperOnboardRef?.current?.swiper?.activeIndex) {
      case 0:
        nicknameRef.current.requestSubmit();
        break;
      case 1:
        swiperOnboardRef?.current?.swiper?.slideNext();
        break;
      case 2:
        termsRef.current.requestSubmit();
        break;
      default:
        break;
    }
  };

  const exitOnboarding = () => {
    dispatch({ type: "setHideBottomBar", value: false });
    history.push("/");
  };

  return (
    <IonPage
      style={{
        "--image-url": `url(https://firebasestorage.googleapis.com/v0/b/oles-test-project.appspot.com/o/common%2Fstadium.png?alt=media&token=7075d1e6-b2d6-48e1-ae5e-5f12d570d847)`,
      }}
      className="bg-[image:var(--image-url)] h-full bg-no-repeat bg-center bg-cover"
    >
      <IonHeader mode="ios" className="ion-no-border" translucent={true}>
        <IonToolbar className="gradientToolbarPrimary">
          <IonTitle>
            <div className="flex items-center justify-center animate-wiggle">
              <AppLogo size={"small"} />
            </div>
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <div className="bg-gradient-to-b  from-headerPrimary/80 to-black/50 h-full ">
        <IonContent className="transparent">
          <swiper-container
            ref={swiperOnboardRef}
            init="false"
            class="h-full w-full bg-transparent"
          >
            <swiper-slide class="noSwipingClass " key={0}>
              {isLoading || user == null ? (
                <div className="flex flex-col justify-center items-center h-full text-white">
                  <Md2Loading className="h-12 w-12 shrink-0 text-white cursor-pointer animate-spin" />
                  <span className="flex pt-2">Signing in...</span>
                </div>
              ) : (
                <Nickname
                  swiperRef={swiperOnboardRef}
                  formRef={nicknameRef}
                  setIsLoading={setIsSubmitting}
                />
              )}
            </swiper-slide>
            <swiper-slide class="noSwipingClass overflow-y-auto" key={1}>
              {userGameData == null ? (
                <div className="flex flex-col justify-center items-center h-full text-white">
                  <Md2Loading className="h-12 w-12 shrink-0 text-white cursor-pointer animate-spin" />
                  <span className="flex pt-2">Loading...</span>
                </div>
              ) : (
                <Photo swiperRef={swiperOnboardRef} />
              )}
            </swiper-slide>
            <swiper-slide class="noSwipingClass overflow-auto" key={2}>
              <TermsAndConditions
                swiperRef={swiperOnboardRef}
                formRef={termsRef}
                setIsLoading={setIsSubmitting}
                exitOnboarding={exitOnboarding}
              />
            </swiper-slide>
          </swiper-container>
        </IonContent>
      </div>
      <IonFooter mode="ios" className="transparent bg-black/50 pb-2 px-3.5">
        <IonButton
          color="success"
          expand="block"
          mode="ios"
          type="submit"
          shape="round"
          disabled={isSubmitting}
          onClick={(e) => submitForm(e)}
          className="customButtonNew rounded-md mt-4 p-0"
        >
          <IonLabel className="text-black">{t("common.continue")}</IonLabel>
          <IonLabel slot="end">
            <Md2Loading
              className={classNames(
                "ml-1 h-6 w-6",
                isSubmitting ? "animate-spin opacity-100" : "opacity-0"
              )}
            />
          </IonLabel>
        </IonButton>
      </IonFooter>
    </IonPage>
  );
};

export default NewUserOnboarding;
